// extracted by mini-css-extract-plugin
module.exports = {"items":"CartProducts_items__aGidl"};